// extracted by mini-css-extract-plugin
export default {"root":"Fees_root__mHS56","lastUpdated":"Fees_lastUpdated__G40o+ marketplaceBodyFontStyles","scopedList":"Fees_scopedList__kHmVk"};